import styled from 'styled-components';

export const Wrapper = styled.div<{ $isReverse?: boolean }>`
	position: relative;
	width: 100%;
	z-index: 2;
	display: flex;
	flex-direction: ${({ $isReverse }) => ($isReverse ? 'row-reverse' : 'row')};
	align-items: center;
	justify-content: space-between;

	@media (max-width: 992px) {
		flex-direction: column;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Info = styled.div`
	font-size: 18px;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.colors.text.body};
	max-width: 672px;
	width: 100%;
	margin: 20px 0;

	@media (max-width: 992px) {
		font-size: 16px;
	}
`;

export const Text = styled.div`
	margin-top: 4px;
`;

export const Title = styled.div`
	font-size: 48px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};

	span {
		color: ${({ theme }) => theme.colors.control.primary};
	}

	@media (max-width: 992px) {
		font-size: 28px;
	}
`;

export const ButtonGroup = styled.div`
	display: flex;
	gap: 16px;
`;

export const Image = styled.img`
	max-width: 610px;
	width: 100%;
`;
